var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from '@emotion/styled';
import { TableCell as MuiTableCell } from '@mui/material';
import Text from '../../Text';
import Tooltip from '../../Tooltip';
import colors from '../../../themes/colors';
import getCellAlignment from './getCellAlignment';
var HeaderCellWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n  & > svg {\n    margin-bottom: -3px;\n    margin-left: 4px;\n    ", "\n  }\n"], ["\n  display: inline-block;\n  & > svg {\n    margin-bottom: -3px;\n    margin-left: 4px;\n    ", "\n  }\n"])), function (_a) {
    var variant = _a.variant;
    if (variant === 'celes' || variant === 'altered') {
        return "\n          & path {\n            fill: ".concat(colors.neutral90, ";\n          }\n        ");
    }
    return '';
});
export function renderHeaderCell(args) {
    var _a;
    var columnConfig = args.column, variant = args.variant, index = args.index;
    var isAltered = variant === 'altered';
    var isExpandable = variant === 'expandable';
    var style = {
        backgroundColor: colors.white,
        userSelect: 'none',
        width: (_a = columnConfig.width) !== null && _a !== void 0 ? _a : 'auto',
        zIndex: isExpandable ? 3 : 2,
        position: 'relative'
    };
    var alignment = getCellAlignment({
        cellArgs: {
            index: index,
            isHovering: false,
            rowIndex: -1,
            cell: columnConfig.key
        },
        config: columnConfig
    });
    return (_jsx(MuiTableCell, __assign({ align: alignment, component: "th", sx: style }, { children: _jsxs(HeaderCellWrapper, __assign({ variant: variant }, { children: [_jsx(Text, __assign({ ellipsis: true, color: "neutral80", variant: "tableH1" }, { children: _jsx("span", __assign({ style: { fontWeight: isAltered ? 600 : 'inherit' } }, { children: columnConfig.label })) })), columnConfig.tooltip && _jsx(Tooltip, __assign({ size: "small", info: true, arrow: true, placement: "bottom" }, columnConfig.tooltip))] })) }), columnConfig.label));
}
var templateObject_1;
